var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footerpart",attrs:{"app":"","inset":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }